<script lang="ts" setup>
import AppFooter from "@/components/mobile/AppFooter.vue";
import api from "@/modules/api";
import { clearCache } from "@/modules/common";
import { useAppUpdate } from "@/stores/appUpdate";
import { useGlobalUser } from "@/stores/globalUser";
import { useMate } from "@/stores/mate";
import { ref } from "vue";
import { useRouter } from "vue-router";

const mateStore = useMate();

const emit = defineEmits([
  "onShowBottom",
  "onShowBottomLanguage",
  "onClose",
  "onShowBottomNew",
  "showWechat",
]);
const mate = useMate();
const router = useRouter();
const userStore = useGlobalUser();
const appUpdateStore = useAppUpdate();
const showAppearanceSetting = ref(false);

const logout = async () => {
  await api.signOut();
  userStore.logout();
};

const clickWechat = () => {
  emit("onClose");
  emit("showWechat");
};
</script>
<template>
  <div class="p-4 flex flex-col gap-1 min-w-[280px]">
    <template v-if="userStore.isLogin">
      <div class="van-safe-area-top flex justify-between items-start px-4">
        <div class="flex flex-col gap-1">
          <h1 class="text-xl font-semibold">{{ userStore.name }}</h1>
          <div class="flex items-center gap-2">
            <!-- <MembershipBadge /> -->
            <p class="text-xs text-base-content/50">
              UUID: {{ userStore.id.toString().padStart(5, "0") }}
            </p>
          </div>
        </div>
        <ThemeSwitcher @close="emit('onClose')" />
      </div>
      <!--      <div class="flex flex-col gap-2 mt-2 px-4">-->
      <!--        <div class="flex items-center gap-2 text-sm">-->
      <!--          <i class="iconfont icon-coin" />-->
      <!--          {{ $t("Coin.coin") }}:-->
      <!--          <span v-if="userStore.fetching" class="loading loading-xs" />-->
      <!--          <span v-else>{{ userStore.coinAmount }}</span>-->
      <!--          <button-->
      <!--            class="btn btn-xs text-base-content/50 rounded btn-primary font-normal"-->
      <!--            @click="router.push({ name: 'coinTask' })"-->
      <!--          >-->
      <!--            {{ $t("Coin.getCoin") }}-->
      <!--          </button>-->
      <!--        </div>-->
      <!--        <div-->
      <!--          v-if="userStore.isReviewer"-->
      <!--          class="flex items-center gap-2 text-sm"-->
      <!--        >-->
      <!--          <i class="iconify mdi&#45;&#45;ticket text-my-yellow text-xs" />-->
      <!--          {{ $t("Coin.goldTicket") }}:-->
      <!--          <span v-if="userStore.fetching" class="loading loading-xs" />-->
      <!--          <span v-else>{{ userStore.goldenTicketAmount }}</span>-->
      <!--          <button-->
      <!--            class="btn btn-xs text-base-content/50 rounded btn-primary font-normal"-->
      <!--            @click="router.push({ name: 'goldTicketBalance' })"-->
      <!--          >-->
      <!--            {{ $t("Coin.getGoldTicket") }}-->
      <!--          </button>-->
      <!--        </div>-->
      <!--        <user-identity />-->
      <!--      </div>-->
      <!-- <div class="divider my-1"></div> -->
      <!--   头像   -->
      <!-- <div class="flex flex-col gap-2 px-4">
        <h2 class="font-semibold">
          {{ $t(`SidebarNavi.currentMate`) }}
        </h2>
        <MateInfo :mate="mate.currentMate!" hasRouter />
        <div class="mt-1.5 flex items-center">
          <button
            class="btn btn-xs btn-neutral mr-2.5"
            @click="$emit('onClose'), mateStore.clickCreateMate()"
          >
            <i class="iconfont icon-a- text-xs" />
            {{ $t("SidebarNavi.new") }}
          </button>
          <button class="btn btn-xs btn-neutral" @click="$emit('onShowBottom')">
            <i class="iconfont icon-switch" />
            {{ $t("SidebarNavi.switch") }}
          </button>
        </div>
      </div> -->
    </template>
    <template v-else>
      <div>
        <LogoIcon class="w-32" />
      </div>
    </template>

    <div class="divider my-1"></div>
    <!--   导航   -->
    <div>
      <!-- <ul class="menu p-0">
        <li  @click="$router.push(`/crystal`)">
          <a class="flex justify-between w-full flex-grow">
            <div class="flex items-center gap-2">
              <i class="iconify mingcute--diamond-2-line" />
              {{ $t("Payment.deposit") }}
            </div>

            <div class="flex items-center cursor-pointer">
              <div class="flex items-center">
                <img
                  :src="usePowerUrl()"
                  alt=""
                  class="w-[14px] mx-1"
                  crossorigin="anonymous"
                />
                <div class="text-xs">
                  {{ userStore.user.powerAmount || 0 }}
                </div>
              </div>
              <div class="flex items-center">
                <img
                  :src="useCrystalUrl()"
                  alt=""
                  class="w-[20px] mx-1"
                  crossorigin="anonymous"
                />
                <div class="text-xs">
                  {{ userStore.user.crystalQuantity || 0 }}
                </div>
              </div>
            </div>
          </a>
        </li>
        <li>
          <a @click="router.push({ name: 'transaction' })">
            <i class="iconify mingcute--receive-money-line" />
            {{ $t("Payment.title") }}
          </a>
        </li>
      </ul>
      <div class="divider my-1"></div> -->
      <ul class="menu p-0">
        <!-- <li>
          <a
            @click="
              showAppearanceSetting = true;
              $emit('onClose');
            "
          >
            <i class="iconify mingcute--layout-line" />
            {{ $t("SidebarNavi.chatAppearanceSettings") }}
          </a>
        </li> -->
        <!-- <li>
          <a @click="$emit('onShowBottomLanguage')">
            <i class="iconify mdi--language" />
            {{ $t("SidebarNavi.language") }}
          </a>
        </li> -->
        <li>
          <a
            @click="
              $emit('onClose');
              appUpdateStore.checkUpdate();
            "
          >
            <i class="iconify mingcute--large-arrow-up-line" />
            {{ $t("SidebarNavi.checkUpdate") }}
          </a>
        </li>
        <li>
          <a @click="clearCache">
            <i class="iconify mdi--content-save-off-outline" />
            {{ $t("SidebarNavi.clearCache") }}
          </a>
        </li>

        <span class="divider my-1" />
        <li>
          <a @click="router.push({ name: 'setting' })">
            <i class="iconify mingcute--settings-3-line" />
            {{ $t("SidebarNavi.setting") }}
          </a>
        </li>
        <li>
          <a @click="logout">
            <i class="iconify mingcute--exit-line" />
            {{ $t("SidebarNavi.logout") }}
          </a>
        </li>
      </ul>
    </div>

    <!-- <div class="flex-1 flex flex-col justify-end gap-2 mt-10 pl-4">
      <template v-if="!inApp">
        <div>{{ $t("SidebarNavi.downloadApp") }}</div>
        <div class="flex gap-2 mb-2">
          <div class="flex items-center justify-center gap-1 w-full">
            <AppStoreDownloadBtn class="flex-1 w-24" />
            <ApkDownloadBtn class="flex-1 w-24" />
          </div>
        </div>
      </template>

      <div>{{ $t("SidebarNavi.feedback") }}</div>
      <div class="flex flex-col w-full">
        <div class="flex gap-1">
          <SocialMediaBtnGroup />
        </div>
      </div>
    </div> -->
    <app-footer />
    <AppearanceSettingPopup v-model:show="showAppearanceSetting" />
  </div>
</template>
